/** MatDialog panelClass for parent-shell modals (add duty, add kid, pending kid, etc.). */
export const PARENT_DIALOG_PANEL_CLASS = 'parent-dialog-panel';

/** Wider parent-shell panel for admin course edit. */
export const COURSE_EDIT_DIALOG_PANEL_CLASS = 'course-edit-dialog-panel';
